import React from 'react'
import { Link } from 'react-router-dom'
import Home from './Home';



const Header = () => {

  return (
    <div> 
           <div>
  {/* Spinner Start */}
  <div id="spinner" className="show bg-white position-fixed translate-middle w-100 vh-100 top-50 start-50 d-flex align-items-center justify-content-center">
    <div className="spinner" />
  </div>
  {/* Spinner End */}
  {/* Topbar Start */}
  <div className="container-fluid bg-dark px-5 d-none d-lg-block">
    <div className="row gx-0">
      <div className="col-lg-8 text-center text-lg-start mb-2 mb-lg-0">
        <div className="d-inline-flex align-items-center" style={{height: 45}}>
          <small className="me-3 text-light"><i className="fa fa-map-marker-alt me-2" />32 Lm Muthu Complex,100 Feet Road,Karaikudi-630001 </small>
          <small className="me-3 text-light"><i className="fa fa-phone-alt me-2" />+91 86672 02180 </small>
          <small className="text-light"><i className="fa fa-envelope-open me-2" />acrosyskkdi@gmail.com</small>
        </div>
      </div>
      <div className="col-lg-4 text-center text-lg-end">
        <div className="d-inline-flex align-items-center" style={{height: 45}}>
          <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href><i className="fab fa-twitter fw-normal" /></a>
          <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href><i className="fab fa-facebook-f fw-normal" /></a>
          <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href><i className="fab fa-linkedin-in fw-normal" /></a>
          <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle me-2" href><i className="fab fa-instagram fw-normal" /></a>
          <a className="btn btn-sm btn-outline-light btn-sm-square rounded-circle" href="https://www.youtube.com/channel/UCzKY8UsXCkNhUNOCuJ4LpGw"><i className="fab fa-youtube fw-normal" /></a>
        </div>
      </div>
    </div>
  </div>
  {/* Topbar End */}
  {/* Navbar & Carousel Start */}
  <div className="container-fluid position-relative p-0">
    <nav className="navbar navbar-expand-lg navbar-dark px-5 py-3 py-lg-0">
      <a href="" className="navbar-brand p-0">
        <h1 className="m-0">Acrosys Technologies</h1>
      </a>
      <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse">
        <span className="fa fa-bars" />
      </button>
      <div className="collapse navbar-collapse" id="navbarCollapse">
        <div className="navbar-nav ms-auto py-0">
          <Link to="/" className="nav-item nav-link">Home</Link>
          <Link to="/about" className="nav-item nav-link">About</Link>
          <Link to="/service" className="nav-item nav-link">Services</Link>
          <div className="nav-item dropdown">
            <a  className="nav-link dropdown-toggle" data-bs-toggle="dropdown">Courses</a>
            <div className="dropdown-menu m-0">
              <Link to="/angular" className="dropdown-item">Angular</Link>
              <Link to="/corejava" className="dropdown-item">Core Java</Link>
              <Link to="/javafullstack" className="dropdown-item">Java Fullstack</Link>
              <Link to="/dotnet" className="dropdown-item">Dot net Fullstack</Link>
              <Link to="/php" className="dropdown-item">PHP Fullstack</Link>
              <Link to="/python" className="dropdown-item">Python</Link>
              <Link to="/hardware" className="dropdown-item">Hardware &amp; Networking</Link>
              <Link to="/frontend" className="dropdown-item">Html,Css,Js,Bs (Frontend Developer)</Link>
              <Link to="/photoshop" className="dropdown-item">Photoshop</Link>
              <Link to="/illustrator" className="dropdown-item">Illustrator</Link>
              <Link to="/testing" className="dropdown-item">Software Testing</Link>
              <Link to="/flutter" className="dropdown-item">Flutter-Dart(Mobile App Developer)</Link>
              <Link to="/sqlserver" className="dropdown-item">Sql Server</Link>
              <Link to="/digitalmarketing" className="dropdown-item">Digital Marketing</Link>
              <Link to="/react" className="dropdown-item">React.js</Link>
              <Link to="/node" className="dropdown-item">Node.js</Link>
              <Link to="/chiplevelservice" className="dropdown-item">Chip Level Service</Link>
            </div>
          </div>
        
          <Link to="/careers" className="nav-item nav-link">Careers</Link>
          
          <Link to="/contact" className="nav-item nav-link">Contact</Link>
        </div>
       
      </div>
    </nav>

  </div>
  {/* Navbar & Carousel End */}
  {/* Full Screen Search Start */}
  <div className="modal fade" id="searchModal" tabIndex={-1}>
    <div className="modal-dialog modal-fullscreen">
      <div className="modal-content" style={{background: 'rgba(9, 30, 62, .7)'}}>
        <div className="modal-header border-0">
          <button type="button" className="btn bg-white btn-close" data-bs-dismiss="modal" aria-label="Close" />
        </div>
        <div className="modal-body d-flex align-items-center justify-content-center">
          <div className="input-group" style={{maxWidth: 600}}>
            <input type="text" className="form-control bg-transparent border-primary p-3" placeholder="Type search keyword" />
            <button className="btn btn-primary px-4"><i className="bi bi-search" /></button>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* Full Screen Search End */}
</div>

<Home/>
    </div>

  )
}

export default Header